import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map, take } from 'rxjs/operators';
import { PolicyProvisioningStore } from '../../shared/stores/policy-provisioning.store';
import { CustomerStore } from '../../shared/stores/customer.store';
import { AppNavigationService } from '../services/app-navigation.service';

/**
 * Protects Policy Management routes (e.g. `/policies`) so a deep link cannot
 * bypass the hidden Policy tab when the tenant is NOT provisioned for PM.
 *
 * Ensures the provisioning check has loaded (the load itself is idempotent),
 * then allows navigation only when provisioned; otherwise redirects to Home.
 */
export const policyProvisionedGuard: CanActivateFn = () => {
  const store = inject(PolicyProvisioningStore);
  const customerStore = inject(CustomerStore);
  const appNav = inject(AppNavigationService);

  // Idempotent — the store skips re-loading once resolved.
  store.load(customerStore.customerId());

  return toObservable(store.loaded).pipe(
    filter((loaded) => loaded),
    take(1),
    map(() => (store.canShowPolicy() ? true : appNav.createUrlTree('/home')))
  );
};
